<app-menu-common url="hr"></app-menu-common>

@if (hrService.backendMissing()) {
	<div class="hr-backend-warn">Backend RH non déployé : données indisponibles (voir docs/backend-brief-hr.md).</div>
}

<div class="flexrow hr-header">
	<button mat-icon-button aria-label="Mois précédent" (click)="onPrevMonth()">
		<mat-icon>chevron_left</mat-icon>
	</button>
	<span class="period-label" [matTooltip]="periodRange">{{ periodLabel }}</span>
	<button mat-icon-button aria-label="Mois suivant" (click)="onNextMonth()">
		<mat-icon>chevron_right</mat-icon>
	</button>
	<button mat-stroked-button class="hr-btn" (click)="onToday()">Ce mois-ci</button>

	@if (enabled) {
		<span class="source-chip" matTooltip="D'où viennent les horaires qui décident de la journée coupée">
			<mat-icon>{{ rules.time_source === 'clock' ? 'fingerprint' : 'event_note' }}</mat-icon>&nbsp;{{ sourceLabel }}
		</span>
		<span class="pivot-chip" matTooltip="La charnière du repas : il faut travailler de part et d'autre">
			<mat-icon>restaurant</mat-icon>&nbsp;Repas à {{ pivotLabel }}
		</span>
	}

	<span class="spacer"></span>

	<mat-form-field class="store-select">
		<mat-label>Magasin</mat-label>
		<mat-select [formControl]="storeCtrl">
			<mat-option [value]="null">Tous</mat-option>
			@for (s of stores; track s.id) {
				<mat-option [value]="s.id">{{ s.name }}</mat-option>
			}
		</mat-select>
	</mat-form-field>

	@if (isAdmin && enabled) {
		<button mat-flat-button color="primary" class="hr-btn" (click)="onAddMeals()"
			matTooltip="Formation, note de frais, repas d'affaires : ces jours-là, pas de titre">
			<mat-icon>restaurant</mat-icon>&nbsp;Repas d'entreprise
		</button>
	}
	@if (enabled) {
		<button mat-stroked-button class="hr-btn" (click)="onExport()" [disabled]="!report"
			matTooltip="Le récapitulatif : commande de titres et retenue de paie">
			<mat-icon>download</mat-icon>&nbsp;Export
		</button>
		<button mat-stroked-button class="hr-btn" (click)="onExportDetail()" [disabled]="!report"
			matTooltip="Le détail jour par jour — la pièce justificative">
			<mat-icon>list_alt</mat-icon>&nbsp;Détail
		</button>
		<button mat-stroked-button class="hr-btn order-btn" (click)="onExportSwile()" [disabled]="!report"
			matTooltip="Le fichier de commande à déposer chez l'émetteur (Swile) : Nouvelle commande ▸ Importer via fichier">
			<mat-icon>local_shipping</mat-icon>&nbsp;Commande émetteur
		</button>
	}
</div>

<!-- ─────────── Titres non activés : rien à compter, on dit pourquoi ─────────── -->
@if (!enabled) {
	<div class="meal-off">
		<mat-icon>restaurant</mat-icon>
		<div>
			<b>L'entreprise ne propose pas de titres-restaurant.</b>
			<p>
				Pour les activer, ouvrir <a routerLink="/hr/organization">Établissements &amp; services</a>,
				panneau <b>Règles de paie ▸ Titres-restaurant</b> : valeur du titre, part patronale, et les
				durées de travail exigées de part et d'autre du repas.
			</p>
		</div>
	</div>
} @else {

<!-- ─────────── Ce qu'il y a à commander et à retenir ─────────── -->
@if (report) {
	<div class="meal-totals">
		<div class="tot main">
			<span class="tot-value">{{ report.granted }}</span>
			<span class="tot-label">titre{{ report.granted > 1 ? 's' : '' }} à commander</span>
			<span class="tot-sub">{{ faceValue }} l'unité</span>
		</div>
		<div class="tot">
			<span class="tot-value">{{ euros(report.total_value) }}</span>
			<span class="tot-label">valeur totale</span>
		</div>
		<div class="tot employer">
			<span class="tot-value">{{ euros(report.employer_amount) }}</span>
			<span class="tot-label">à la charge de l'entreprise</span>
			<span class="tot-sub">{{ employerShare }} par titre</span>
		</div>
		<div class="tot employee">
			<span class="tot-value">{{ euros(report.employee_amount) }}</span>
			<span class="tot-label">retenue sur les bulletins</span>
			<span class="tot-sub">{{ employeeShare }} par titre</span>
		</div>
		@if (report.company_meals > 0) {
			<div class="tot meals">
				<span class="tot-value">{{ report.company_meals }}</span>
				<span class="tot-label">repas payés par l'entreprise</span>
				<span class="tot-sub">autant de titres écartés</span>
			</div>
		}
		@if (report.employer_excess > 0) {
			<div class="tot excess" matTooltip="Part patronale au-delà du plafond d'exonération : à réintégrer dans l'assiette des cotisations">
				<span class="tot-value">{{ euros(report.employer_excess) }}</span>
				<span class="tot-label">excédent à réintégrer</span>
			</div>
		}
	</div>

	@for (w of warnings; track w.text) {
		<div class="meal-warning" [class.level-error]="w.level === 'error'">
			<mat-icon>{{ w.level === 'error' ? 'gpp_maybe' : 'info' }}</mat-icon>
			<span>{{ w.text }}</span>
			<a routerLink="/hr/organization">Corriger le paramétrage</a>
		</div>
	}
}

<!-- ─────────── Une ligne par salarié, dépliable jour par jour ─────────── -->
<div class="table-wrap">
	<table class="meal-table">
		<thead>
			<tr>
				<th class="name">Salarié</th>
				<th class="num" matTooltip="Journées coupées par le repas, hors absence et hors repas payé">Titres</th>
				<th class="num">Repas entreprise</th>
				<th class="num">Jours travaillés</th>
				<th class="num">Absences</th>
				<th class="num">Valeur</th>
				<th class="num">Part entreprise</th>
				<th class="num" matTooltip="Le montant à retenir sur le bulletin de paie">Retenue salarié</th>
				<th class="act"></th>
			</tr>
		</thead>
		<tbody>
			@for (l of shownLines; track l.id_employee) {
				<tr class="row" [class.open]="openEmployee === l.id_employee" [class.excluded]="!l.eligible"
					(click)="toggleDetail(l)">
					<td class="name">
						{{ l.name }}
						@if (!l.eligible) {
							<span class="tag" matTooltip="Exclu des titres-restaurant sur sa fiche">exclu</span>
						}
					</td>
					<td class="num strong" [class.zero]="!l.granted">{{ l.granted || '—' }}</td>
					<td class="num" [class.zero]="!l.company_meals_total">{{ l.company_meals_total || '—' }}</td>
					<td class="num">{{ l.worked_days }}</td>
					<td class="num" [class.zero]="!l.absence_days">{{ l.absence_days || '—' }}</td>
					<td class="num" [class.zero]="!l.granted">{{ l.granted ? euros(l.total_value) : '—' }}</td>
					<td class="num" [class.zero]="!l.granted">{{ l.granted ? euros(l.employer_amount) : '—' }}</td>
					<td class="num strong" [class.zero]="!l.granted">{{ l.granted ? euros(l.employee_amount) : '—' }}</td>
					<td class="act">
						<mat-icon>{{ openEmployee === l.id_employee ? 'expand_less' : 'expand_more' }}</mat-icon>
					</td>
				</tr>

				@if (openEmployee === l.id_employee) {
					<tr class="detail-row">
						<td colspan="9">
							<div class="detail">
								<div class="detail-head">
									Le détail du mois — {{ l.days.length }} journée{{ l.days.length > 1 ? 's' : '' }} ayant
									quelque chose à dire. Les jours de repos sans repas saisi n'y figurent pas.
								</div>
								<table class="day-table">
									<thead>
										<tr>
											<th>Jour</th>
											<th>Horaires</th>
											<th class="num">Avant {{ pivotLabel }}</th>
											<th class="num">Après</th>
											<th class="num">Travail</th>
											<th>Titre</th>
											<th class="act"></th>
										</tr>
									</thead>
									<tbody>
										@for (d of l.days; track d.dat) {
											<tr [class.granted]="d.granted" [class.mealday]="d.reason === 'company_meal'">
												<td>{{ dayLabel(d.dat) }}</td>
												<td class="hours">
													{{ rangeLabel(d) }}
													@if (d.source === 'clock') {
														<mat-icon class="src" matTooltip="Horaires badgés">fingerprint</mat-icon>
													}
												</td>
												<td class="num" [class.short]="d.reason === 'too_short' || d.reason === 'no_break'">
													{{ d.before_min ? hours(d.before_min) : '—' }}
												</td>
												<td class="num" [class.short]="d.reason === 'too_short' || d.reason === 'no_break'">
													{{ d.after_min ? hours(d.after_min) : '—' }}
												</td>
												<td class="num">{{ d.worked_min ? hours(d.worked_min) : '—' }}</td>
												<td class="verdict">
													@if (d.granted) {
														<mat-icon class="ok">check_circle</mat-icon> 1 titre
													} @else {
														<mat-icon class="no">remove_circle_outline</mat-icon>
														{{ reasonLabel(d) }}
														@if (d.meal_kind !== null) {
															<span class="meal-tag" [matTooltip]="d.meal_comment">
																{{ kindLabel(d.meal_kind) }}
															</span>
														}
													}
												</td>
												<td class="act">
													@if (isAdmin) {
														@if (d.id_meal) {
															<button mat-icon-button (click)="onRemoveMeal(l, d)"
																matTooltip="Retirer ce repas d'entreprise" aria-label="Retirer ce repas d'entreprise">
																<mat-icon>delete_outline</mat-icon>
															</button>
														} @else {
															<button mat-icon-button (click)="onDayMeal(l, d)"
																matTooltip="L'entreprise a payé le repas ce jour-là" aria-label="Marquer un repas d'entreprise ce jour-là">
																<mat-icon>restaurant</mat-icon>
															</button>
														}
													}
												</td>
											</tr>
										}
										@if (!l.days.length) {
											<tr><td colspan="7" class="empty">Aucune journée travaillée sur la période.</td></tr>
										}
									</tbody>
								</table>
							</div>
						</td>
					</tr>
				}
			}
			@if (!shownLines.length && !loading) {
				<tr><td colspan="9" class="empty">Aucun salarié sur ce magasin pour cette période.</td></tr>
			}
		</tbody>
		@if (report && shownLines.length) {
			<tfoot>
				<tr>
					<td class="name">Total</td>
					<td class="num strong">{{ report.granted }}</td>
					<td class="num">{{ report.company_meals }}</td>
					<td class="num"></td>
					<td class="num"></td>
					<td class="num">{{ euros(report.total_value) }}</td>
					<td class="num">{{ euros(report.employer_amount) }}</td>
					<td class="num strong">{{ euros(report.employee_amount) }}</td>
					<td class="act"></td>
				</tr>
			</tfoot>
		}
	</table>
</div>

@if (excludedCount > 0) {
	<p class="aside-hint">
		{{ excludedCount }} salarié{{ excludedCount > 1 ? 's sont exclus' : ' est exclu' }} des titres-restaurant
		sur sa fiche. Le réglage se trouve dans la fiche salarié, onglet <b>Contrat &amp; paie</b>.
	</p>
}

<p class="aside-hint">
	Un titre par journée dont l'horaire coupe le repas — il faut
	<b>{{ hours(rules.meal_vouchers.min_morning_min) }}</b> de travail avant {{ pivotLabel }} et
	<b>{{ hours(rules.meal_vouchers.min_afternoon_min) }}</b> après. Les jours d'absence, de congé et de
	repos n'en ouvrent aucun, pas plus que les jours où l'entreprise a payé le repas.
	Ces règles se modifient dans <a routerLink="/hr/organization">Établissements &amp; services</a>.
</p>

}
